import { Injectable } from "@angular/core";
import { MerchantService, TestMidCondition } from "./merchant.service";

const localStorageKey = 'prod-mode-enabled';

@Injectable({ providedIn: 'root' })
export class DevModeChooserService {
    constructor(
        private merchantService: MerchantService
    ) { }

    public get prodModeEnabled(): boolean {
        if (this.merchantService.getTestMidCondition() !== TestMidCondition.Test) {
            return false;
        }

        return localStorage.getItem(localStorageKey) !== 'false';
    }

    public set prodModeEnabled(value: boolean) {
        if (this.merchantService.getTestMidCondition() === TestMidCondition.Test) {
            localStorage.setItem(localStorageKey, value ? 'true' : 'false');
        }
    }
}
